import { render, staticRenderFns } from "./FoodInfo.vue?vue&type=template&id=3e49c677&scoped=true"
import script from "./FoodInfo.vue?vue&type=script&lang=js"
export * from "./FoodInfo.vue?vue&type=script&lang=js"
import style0 from "./FoodInfo.vue?vue&type=style&index=0&id=3e49c677&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49c677",
  null
  
)

export default component.exports